module.exports = __webpack_public_path__ + "static/media/plant.db4c1da8.svg";